export default __webpack_public_path__ + "assets/front/scss/user-profile.8eb875c88bd20b9a21c3fdd9f4e6508a.css";